import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const Code = styled.code`
  padding: 0.5em;
  font-size: 0.9em;
  color: ${tokens.color.text_default};
  background-color: ${tokens.BRAND_COLORS.lilac_200};
  border-radius: 4px;
`;
